import Service from '../service'
import HrPreviderEmployeeTypeMdl from '@/models/HumanResource/HrPreviredEmployeeType'

export default class extends Service {
    static model = HrPreviderEmployeeTypeMdl
}
